import { useMutation, useQueryClient } from 'react-query';
import { loan_quote_api } from '@axo/shared/data-access/api';
import { applicationKeys } from '../cache-keys/applicationKeys';
import { loan_quote } from '@axo/shared/data-access/types';
import { useAPI } from '@axo/shared/data-access/provider';

export interface ICancelQuote {
  quoteID: string;
  input: Omit<loan_quote.CancelQuoteInput, 'MarketCountry'>;
}

export function useCancelQuote(applicationID: string, marketCountry: string) {
  const client = useQueryClient();
  const api = useAPI();
  return useMutation(
    ({ quoteID, input }: ICancelQuote) =>
      loan_quote_api.cancelLoanQuote(api)(quoteID, {
        ...input,
        MarketCountry: marketCountry,
      }),
    {
      onSuccess: () =>
        client.invalidateQueries(
          applicationKeys.loanQuotes({
            applicationID: applicationID,
          })
        ),
    }
  );
}
